// extracted by mini-css-extract-plugin
export default {"actionsWrapper":"workHistory_actionsWrapper__CF5TC","actionLabel":"workHistory_actionLabel__Eavjw","action":"workHistory_action__J5SDP","worksList":"workHistory_worksList__CLbwx"};